import React from "react";

export default function BecomePartnerPage() {
  const mailToLink = () => {
    const subject = encodeURIComponent("Zgłoszenie do platformy LunGO");
    const body = encodeURIComponent(
      `Dzień dobry,\n\nChciałbym dołączyć do platformy LunGO jako partner.\n\nDane firmy:\n• Nazwa lokalu: \n• Adres: \n• NIP: \n• E-mail kontaktowy: \n\nProszę o kontakt.\n\nPozdrawiam,`
    );
    return `mailto:support@lungoapp.pl?subject=${subject}&body=${body}`;
  };

  return (
    <div style={{ padding: 24, textAlign: "center", fontFamily: "Inter, sans-serif", minHeight: '60vh' }}>
      <h1 style={{ fontSize: 24, marginBottom: 12, alignItems: 'center', justifyContent: 'center' }}>Zostań partnerem LunGO</h1>

      <a
        href={mailToLink()}
        style={{
          display: "inline-block",
          padding: "12px 24px",
          backgroundColor: "#00a082",
          color: "#fff",
          textDecoration: "none",
          borderRadius: 8,
          fontSize: 16,
          fontWeight: "bold",
        }}
      >
        Wyślij zgłoszenie
      </a>

      <p style={{ marginTop: 20, fontSize: 14, color: "#666" }}>
        Otworzy się domyślna aplikacja pocztowa z gotowym szablonem zgłoszenia.
      </p>
    </div>
  );
}
